import { ROUTE_NAME } from 'enums/routes'

export const NEWS_TYPE = {
  FM: 'FM',
  FM_DIR: 'FMDirectory',
  FL: 'FL'
}

export const NOTIFICATION_TYPE = {
  FOLLOWED_TAGS: 'FollowedTags',
  FOLLOWED_AUTHORS: 'FollowedAuthors'
}

export const FOLLOWED_ITEM = {
  TAGS: 'notificationTags',
  CATEGORIES: 'notificationCategories',
  AUTHORS: 'notificationAuthors'
}

export const FOLLOWED_ITEM_METHOD_NAME = {
  UPDATE_IS_FOLLOWED_CATEGORY_VALUE: 'UPDATE_IS_FLLOWED_CATEGORY_VALUE'
}

export const ANNOUNCEMENT_TYPE = {
  EVENTS: 'Events',
  NEWS: 'News',
  PROMOTIONAL: 'Promotional',
  OTHER: 'Other'
}

export const TAB_NAME = {
  ALL: 'All',
  FM: 'Finance Magnates',
  FL: 'Forex Live'
}

export const TAB_QUERY_PARAM_NAME = 'tab'

export const COMPANY_STATUS = {
  ACTIVE: 'Active',
  INACTIVE: 'Inactive',
  UNDER_MODERATION: 'UnderModeration',
  EXPIRING: 'Expiring',
  EXPIRED: 'Expired'
}

export const COMPANY_FEATURE_STATUS = {
  EXPIRING: 'Expiring',
  EXPIRED: 'Expired'
}

export const COMPANY_CONTENT_STATUS = {
  ACTIVE: 'Active',
  INACTIVE: 'Inactive',
  UNDER_MODERATION: 'UnderModeration'
}

export const COMPANY_CONTENT_STATUS_TITLE = {
  [COMPANY_CONTENT_STATUS.ACTIVE]: 'Active',
  [COMPANY_CONTENT_STATUS.INACTIVE]: 'Inactive',
  [COMPANY_CONTENT_STATUS.UNDER_MODERATION]: 'Under Moderation'
}

export const FILTER_TYPE = {
  PHONE: 'Phone',
  EMAIL: 'Email',
  URL: 'Url',
  TEXT_AREA: 'TextArea',
  SELECT: 'Select',
  MULTISELECT: 'MultiSelect',
  RADIO: 'Radio',
  CHECKBOX: 'Checkbox',
  BOOLEAN: 'Boolean'
}

export const QUERY_PARAM_NAME = 'source'

export const QUERY_PARAM_VALUE = {
  [TAB_NAME.FM]: 'fm',
  [TAB_NAME.FL]: 'fl',
  [TAB_NAME.ALL]: 'all'
}

export const MY_DIRECTORY_LISTINGS_CHILD_ROUTE_NAMES = [
  ROUTE_NAME.PERSONAL_PROFILE_COMPANY_NEWS,
  ROUTE_NAME.PERSONAL_PROFILE_COMPANY_VIDEOS,
  ROUTE_NAME.PERSONAL_PROFILE_ADD_COMPANY,
  ROUTE_NAME.PERSONAL_PROFILE_EDIT_COMPANY,
  ROUTE_NAME.PERSONAL_PROFILE_ADD_COMPANY_NEWS,
  ROUTE_NAME.PERSONAL_PROFILE_EDIT_COMPANY_NEWS
]

export const MY_CONTRIBUTIONS_CHILD_ROUTE_NAMES = [
  ROUTE_NAME.PERSONAL_PROFILE_ADD_POST,
  ROUTE_NAME.PERSONAL_PROFILE_EDIT_POST
]

export const INFO_NAVIGATION_SETTINGS = [
  {
    title: {
      desktop: 'General Information',
      mobile: 'General Information'
    },
    link: '?tab=info#general-information'
  },
  {
    title: {
      desktop: 'Social Media',
      mobile: 'Social Media'
    },
    link: '?tab=info#social-media'
  },
  {
    title: {
      desktop: 'Newsletters',
      mobile: 'Newsletters'
    },
    link: '?tab=info#newsletters'
  }
]

export const SETTINGS_NAVIGATION_SETTINGS = [
  {
    title: {
      desktop: 'Following tags',
      mobile: 'Following tags'
    },
    link: '?tab=settings#following-tags'
  },
  {
    title: {
      desktop: 'Following authors',
      mobile: 'Following authors'
    },
    link: '?tab=settings#following-authors'
  },
  {
    title: {
      desktop: 'Following categories',
      mobile: 'Following categories'
    },
    link: '?tab=settings#following-categories'
  },
  {
    title: {
      desktop: 'Announcements',
      mobile: 'Announcements'
    },
    link: '?tab=settings#announcements'
  }
]
